import { ApiResult, CrudService, isNotNullOrUndefinedOrEmpty, Meta } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    PdmVersaoEntity,
    ProdutoAtributosModificadosEntity,
    ProdutoEntity, ProdutoGerenciamentoRiscoEntity,
    ProdutoSaneadoEntity
} from '@catalogo/models';
import {
    ProdutoSituacaoAtributoModificadoEntity,
    ProdutoSituacaoBacklogEntity,
    ProdutoSituacaoValidadoEntity
} from "@catalogo/models/produtos-situacao.entity";
import {
    FiltroArquivosExportacaoProdutoVersao,
    FiltroVersoesExportacaoProdutoVersao
} from '@catalogo/features/operacional/catalogo/catalogo-modal-exportacao-versoes/catalogo-modal-exportacao-versoes.component';
import { SolicitacaoProcessamentoEntity } from '@catalogo/models/solicitacao-processamento.entity';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";
import {
    EnumOrigemAutomacaoAtributosModificados,
    EnumTipoAutomacaoAtributosModificados
} from '@catalogo/features/operacional/enums/enum-entities';
import { NcmAtributosModificadosEntity } from "@catalogo/models/operacional";

@Injectable({ providedIn: 'root' })
export class  ProdutoDataService extends CrudService<ProdutoEntity> {

    protected url: string;
    protected urlPdm: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.url = `${urlBase}/v1/produto`;
        this.urlPdm = `${urlBase}/v1/pdm`;
    }

    public obterTodosSaneados = (meta: Meta) => this.getWithQueryBase<ProdutoSaneadoEntity>(this.url + '/Saneado', meta);

    public exportarPlanilha = (filtro: string, ordenacao: string, filtroVersoes: FiltroVersoesExportacaoProdutoVersao, filtroArquivos: FiltroArquivosExportacaoProdutoVersao) =>
        this.httpClient.post<ApiResult<any>>(`${this.url}/Versao/Exportacao`, {filtro, ordenacao, filtroVersoes, filtroArquivos});

    public getSituacaoBacklog = () => this.httpClient.get<ApiResult<ProdutoSituacaoBacklogEntity>>(`${this.url}/Situacao/Backlog`);
    public getSituacaoValidados = () => this.httpClient.get<ApiResult<ProdutoSituacaoValidadoEntity>>(`${this.url}/Situacao/Validados`);
    public getSituacaoAtributosModificados = () => this.httpClient.get<ApiResult<ProdutoSituacaoAtributoModificadoEntity>>(`${this.url}/Situacao/AtributosModificados`);

    //TODO: remover daqui e utilizar o PdmDataService
    public getPdmVersoes = (pdmId: string, filtro?: string) => {
        let url =  `${this.urlPdm}/${pdmId}/Versao`;

        if(isNotNullOrUndefinedOrEmpty(filtro)){
            url += "?filtro=" + filtro;
        }
        return this.httpClient.get<PdmVersaoEntity>(url)
    };

    public marcarNcmVerificado = (id: string) => this.httpClient.post<ApiResult<string>>(`${this.url}/Ncm/${id}/Verificado`, id);
    public marcarProdutoVerificado = (id: string) => this.httpClient.post<ApiResult<string>>(`${this.url}/${id}/Verificado`, id);

    public obterTodosVerificados = (meta: Meta) => this.getWithQueryBase<NcmAtributosModificadosEntity>(this.url + '/AtributosModificados', meta);
    public importar = (payload: FormData) => this.httpClient.post<any>(`${this.url}/Importar`, payload);
    public obterUltimaSolicitacao = () => this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(this.url + '/Importar/Atual');
    public removerPriorizacao = (produtoId: string) => this.httpClient.put(`${this.url}/${produtoId}/RemoverPriorizacao`, null)
    public downloadRetornoImportacaoPlanilha = () =>
        this.httpClient.get<ApiResult<any>>(`${this.url}/Importar/Retorno`);
    public exportar = (meta: Meta, tipoExportacao: string) =>
        this.httpClient.post<ApiResult<string>>(`${this.url}/Exportar`, { ...meta, tipoExportacao });

    public obterProdutosPorNcm = (ncmId: string, meta: Meta) => this.getWithQueryBase<ProdutoAtributosModificadosEntity>(`${this.url}/AtributosModificados/Ncm/${ncmId}/produtos`, meta);

    public downloadRetornoExportacao = () =>
        this.httpClient.get<ApiResult<any>>(`${this.url}/Exportar/Retorno`);

    public obterUltimaSolicitacaoExportacao = () =>
        this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(`${this.url}/Exportar/Atual`);

    public exportarAtributosModificados = (meta: Meta) => {
        return this.httpClient.post<ApiResult<string>>(`${this.url}/AtributosModificados/Exportar`, meta);
    }

    public downloadRetornoExportacaoAtributosModificados = () =>
        this.httpClient.get<ApiResult<any>>(`${this.url}/AtributosModificados/Exportar/Retorno`);

    public obterUltimaSolicitacaoExportacaoAtributosModificados  = () =>
        this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(`${this.url}/AtributosModificados/Exportar/Atual`);

    public solicitarAutomacaoAtributosModificados = (meta: Meta, tipoAutomacao: EnumTipoAutomacaoAtributosModificados, origem: EnumOrigemAutomacaoAtributosModificados, ncmId?: string) =>
        this.httpClient.post<ApiResult<string>>(`${this.url}/AtributosModificados/Solicitar`, { ...meta, tipoAutomacao, origem, ncmId: ncmId || null} );

    public obterUltimaSolicitacaoAutomacao = (idControle: string) =>
        this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(`${this.url}/AtributosModificados/${idControle}/Atual`);

    public obterProdutosUltimaVersaoInativa = (meta: Meta) =>
        this.getWithQueryBase<ProdutoAtributosModificadosEntity>(`${this.url}/AtributosModificados/UltimaVersaoInativa`, meta);

    public obterGerenciamentoRisco = (meta: Meta) =>
        this.getWithQueryBase<ProdutoGerenciamentoRiscoEntity>(`${this.url}/GerenciamentoRisco`, meta);

    public obterGerenciamentoRiscoRetificados = (produtoId: string, meta: Meta) =>
        this.getWithQueryBase<ProdutoGerenciamentoRiscoEntity>(`${this.url}/GerenciamentoRisco/${produtoId}/Retificado`, meta);

    public obterGerenciamentoRiscoReclassificados = (produtoId: string, meta: Meta) =>
        this.getWithQueryBase<ProdutoGerenciamentoRiscoEntity>(`${this.url}/GerenciamentoRisco/${produtoId}/Reclassificado`, meta);
}
